/*
	Компілюється у файл
*/
process.env.NODE_ENV === 'production' ? true : require('__page/knowledge-base.html');

/*
	Підключаєм конструктор модулів
*/
const mc = require('__libs/ModuleConstructor.js');
const Share = require('./classes/Share.js');
var Inputmask = require('inputmask');



/**
	Запускаєм конструктор модулів. Аргументом приймає масив назв vue-компонентів,
	які треба включити в процес збірки проекту.
	@type {Array<String>}
*/
mc(['Navigation', 'Slider', 'Form']);

let completeEmail = false;
let showRequiredEmail = false;

let email = new Inputmask({
	mask: window.YAMASTERS_FRONTEND.validator.mask.email,
	greedy: false,
	definitions: {
		'*': {
			validator: "[0-9A-Za-z_-]",
			cardinality: 1,
			casing: "lower"
		},
		'@': {
			validator: '@',
			cardinality: 1,
			casing: 'lower'
		},
		'd': {
			validator: '.',
			cardinality: 1,
			casing: 'lower'
		}
	},
	oncomplete: () => {
		// console.log('oncomplete');
		completeEmail = true;
		showRequiredEmail = false;
	},
	onincomplete: () => {
		completeEmail = false;
	},
	oncleared: () => {
		completeEmail = false;
	}
});
email.mask($('.mail'));




new Share();

/*
	Запускаєм скріпти html компонентів
*/
STACK.forEach(f => {
	f($);
})



// WEBPACK FOOTER //
// ./entries/knowledge-base.js